import { IndustrialProcessType, ProcessStep, ProcessStepModeSchema } from "../types";
import { IndustrialProcess } from "../types/IndustrialProcess";
import { round } from "../utils/round";

const isOtherProcess = (industrialProcess: IndustrialProcessType) => industrialProcess === "OTHER";

const PRECISION = 10;

export const computeCyleTime = ({
  processStep,
  totalQuantity,
  reworkRatio,
}: {
  processStep: ProcessStep;
  totalQuantity: number;
  reworkRatio: number | null;
}): number => {
  const reworkRatioApplies = processStep.industrialProcess !== IndustrialProcess.TRANSPORT;
  const sanitizedReworkRatio = reworkRatioApplies ? reworkRatio || 0 : 0;

  if (processStep.mode === ProcessStepModeSchema.enum.TIME) {
    return round((processStep.otherMachineTime || 0) * totalQuantity, PRECISION);
  }

  if (isOtherProcess(processStep.industrialProcess)) {
    const time = processStep.otherMachineTime || 0;

    return round(time * totalQuantity, PRECISION) * (1 + sanitizedReworkRatio / 100);
  }

  return 0;
};
